class SwymWishlistButton extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.productId = this.dataset.productId
    this.button = this.querySelector('button')

    if (!this.button) return

    if (!this.button.classList.contains('swym-loaded')) {
      this.init(this.productId)
    }
  }

  init(productId) {
    window?.SwymCallbacks?.push(function(swat) {
      swat.initializeActionButtons(`swym-wishlist-button[data-product-id="${productId}"]`)
    })
  }
}

customElements.define('swym-wishlist-button', SwymWishlistButton);
